enum BillingContributionType {
  BONUS = "BONUS",
  PENALTY = "PENALTY",
  CONTRACT_CORRECTION = "CONTRACT_CORRECTION",
}

export default BillingContributionType;
